import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import PublicLayout from "@/components/PublicLayout";

import Home from "@/pages/public/Home";
import Jeu from "@/pages/public/Jeu";
import Acheter from "@/pages/public/Acheter";
import Entreprises from "@/pages/public/Entreprises";
import OuTrouverLeJeu from "@/pages/public/OuTrouverLeJeu";
import ApplicationPage from "@/pages/public/ApplicationPage";
import Actualites from "@/pages/public/Actualites";
import Article from "@/pages/public/Article";
import Contact from "@/pages/public/Contact";
import Faq from "@/pages/public/Faq";
import Avis from "@/pages/public/Avis";
import OrderConfirmation from "@/pages/public/OrderConfirmation";
import Legal from "@/pages/public/Legal";
import NotFound from "@/pages/public/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import OrdersAdmin from "@/pages/admin/OrdersAdmin";
import StockAdmin from "@/pages/admin/StockAdmin";
import PromoAdmin from "@/pages/admin/PromoAdmin";
import PricingAdmin from "@/pages/admin/PricingAdmin";
import DeliveryAdmin from "@/pages/admin/DeliveryAdmin";
import PickupAdmin from "@/pages/admin/PickupAdmin";
import PosAdmin from "@/pages/admin/PosAdmin";
import CorporateAdmin from "@/pages/admin/CorporateAdmin";
import ReviewsAdmin from "@/pages/admin/ReviewsAdmin";
import BlogAdmin from "@/pages/admin/BlogAdmin";
import BlogEdit from "@/pages/admin/BlogEdit";
import MediaAdmin from "@/pages/admin/MediaAdmin";
import ContentAdmin from "@/pages/admin/ContentAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <Routes>
            <Route element={<SiteProvider><PublicLayout /></SiteProvider>}>
              <Route path="/" element={<Home />} />
              <Route path="/jeu" element={<Jeu />} />
              <Route path="/acheter" element={<Acheter />} />
              <Route path="/entreprises" element={<Entreprises />} />
              <Route path="/ou-trouver-le-jeu" element={<OuTrouverLeJeu />} />
              <Route path="/application" element={<ApplicationPage />} />
              <Route path="/actualites" element={<Actualites />} />
              <Route path="/actualites/:slug" element={<Article />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/avis" element={<Avis />} />
              <Route path="/commande/confirmation" element={<OrderConfirmation />} />
              <Route path="/mentions-legales" element={<Legal page="mentions-legales" />} />
              <Route path="/cgv" element={<Legal page="cgv" />} />
              <Route path="/politique-confidentialite" element={<Legal page="politique-confidentialite" />} />
              <Route path="/politique-cookies" element={<Legal page="politique-cookies" />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="commandes" element={<OrdersAdmin />} />
              <Route path="stock" element={<StockAdmin />} />
              <Route path="promos" element={<PromoAdmin />} />
              <Route path="tarifs" element={<PricingAdmin />} />
              <Route path="livraison" element={<DeliveryAdmin />} />
              <Route path="points-retrait" element={<PickupAdmin />} />
              <Route path="points-vente" element={<PosAdmin />} />
              <Route path="entreprises" element={<CorporateAdmin />} />
              <Route path="avis" element={<ReviewsAdmin />} />
              <Route path="blog" element={<BlogAdmin />} />
              <Route path="blog/nouveau" element={<BlogEdit />} />
              <Route path="blog/:id" element={<BlogEdit />} />
              <Route path="medias" element={<MediaAdmin />} />
              <Route path="contenu" element={<ContentAdmin />} />
              <Route path="parametres" element={<SettingsAdmin />} />
            </Route>
          </Routes>
        </AuthProvider>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
